import 'client/javascript/main';
import CollapsePanel from 'client/shared/collapse_panel';
import PictureTooltip from 'client/shared/picture_tooltip';
import { setUpLeadForm } from 'client/shared/dynamic_lead_form';
import { onContentLoaded } from 'client/javascript/on_content_loaded';
import { onPolyfillsLoaded } from 'client/javascript/util/polyfills';
import { setupAmenitiesOverlay } from 'client/javascript/amenities_overlay';
import { setupStickyCtaBar } from 'client/javascript/pages/shared/sticky_cta_bar';
import { SearchStickyBar } from 'client/javascript/pages/product_details/search_sticky_bar';
import { observeNewImagesForLazyLoading } from 'client/javascript/lazy_load';
import { setupCardsArticlesGallery } from 'client/javascript/pages/shared/sections/cards_articles';
import { fetchGeoData, geoData } from 'client/javascript/geo';
import { setupNearbyBuildingsSectionModule } from 'client/javascript/pages/shared/sections/nearby_buildings_slider';
import { setupMediaTextOneAcrossModuleSection } from 'client/javascript/pages/shared/sections/media_text_one_across';
import { CompareModule } from 'client/javascript/pages/shared/sections/compare_module';
import { renderNecessaryModulesBasedOnUserGeolocation as findStickyBarByGeolocationAndShow } from 'client/javascript/pages/shared/location_based_override_module';
import SolutionDetailsData, { SOLUTION_DETAILS_EVENT_NAMES } from './pricing';
import { setupAnalytics, setupWorkspaceNearYouModuleSlider as setupNearbyBuildingsSliderAnalytics } from './analytics';

fetchGeoData();
const { stickyBarSelector, triggerElementSelector } = {
  stickyBarSelector: '#panel_button_filter',
  triggerElementSelector: '.breadcrumbs-wrapper'
};

onContentLoaded(() => {
  onPolyfillsLoaded(async () => {
    const { countryCode } = await geoData;
    const weGlides = setupMediaTextOneAcrossModuleSection();

    findStickyBarByGeolocationAndShow({ countryCode, selector: '[data-conditions-to-show]' });
    setupStickyCtaBar({ triggerElementSelector });
    CollapsePanel.setUp();
    PictureTooltip.setUp();
    setupAmenitiesOverlay();
    setUpLeadForm();
    setupCardsArticlesGallery();
    setupAnalytics(weGlides);

    const solutionsDetailsData = new SolutionDetailsData();
    const { currentSolution: { name: solutionName } = {} } = solutionsDetailsData;
    const searchStickyBar = new SearchStickyBar(solutionsDetailsData, () =>
      setupStickyCtaBar({
        stickyBarSelector,
        triggerElementSelector
      })
    );
    const compareModule = CompareModule.create(solutionsDetailsData.compareSolutions, countryCode);

    solutionsDetailsData.on(SOLUTION_DETAILS_EVENT_NAMES.DATA_UPDATE.USER_150_MILES_MARKET, solutionsDetails => {
      const currentSolutionData = solutionsDetails && solutionName ? solutionsDetails[solutionName] : null;

      setupNearbyBuildingsSectionModule(currentSolutionData, setupNearbyBuildingsSliderAnalytics);
      observeNewImagesForLazyLoading();
    });

    solutionsDetailsData.on(SOLUTION_DETAILS_EVENT_NAMES.DATA_UPDATE.USER_CLOSEST_MARKET, solutionsDetails => {
      if (solutionsDetails == null) {
        return undefined;
      }

      const currentSolutionData = solutionsDetails[solutionName];

      if (currentSolutionData) {
        searchStickyBar.setPrice(currentSolutionData, solutionName);
      }
      compareModule.setPricing(solutionsDetails);
    });
  });
});
